(function () {
  'use strict';

  if (customElements.get('cs-product-sticky')) return;

  class CSProductSticky extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this.classList.toggle('is-visible', false);
      this.setAttribute('aria-hidden', 'true');

      if (document.querySelectorAll('cs-product-sticky').length !== 1) return;

      this._productRoot = document.querySelector('#MainContent .section-main-product main-product[data-section-id]');
      if (!this._productRoot) return;

      this._sectionId = this._productRoot.dataset.sectionId;
      var forms = this._productRoot.querySelectorAll(
        '.product-info__form-wrapper form.product-info__form[data-type="add-to-cart-form"]'
      );
      if (forms.length !== 1) return;

      this._form = forms[0];
      var submitters = this._form.querySelectorAll(
        'button.product-form__btn-add-to-cart[type="submit"][name="add"]'
      );
      if (submitters.length !== 1 || typeof this._form.requestSubmit !== 'function') return;

      this._mainSubmitter = submitters[0];
      this._button = this.querySelector('.cs-product-sticky__button');
      this._image = this.querySelector('.cs-product-sticky__image');
      this._variant = this.querySelector('.cs-product-sticky__variant');
      this._availability = this.querySelector('.cs-product-sticky__availability');
      this._price = this.querySelector('.cs-product-sticky__price');
      this._comparePrice = this.querySelector('.cs-product-sticky__compare-price');
      if (!this._button || !this._availability || !this._price || !this._comparePrice) return;

      this._variantAvailable = !this._mainSubmitter.disabled;
      this._boundClick = this._handleClick.bind(this);
      this._boundVariantChange = this._handleVariantChange.bind(this);
      this._button.addEventListener('click', this._boundClick);
      document.addEventListener('maximize:variant-picker:updated:' + this._sectionId, this._boundVariantChange);
      document.addEventListener('maximize:color-swatch:change:' + this._sectionId, this._boundVariantChange);

      this._buttonObserver = new MutationObserver(this._syncButtonState.bind(this));
      this._buttonObserver.observe(this._mainSubmitter, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
        childList: true,
        characterData: true,
        subtree: true
      });

      this._intersectionObserver = new IntersectionObserver(this._handleIntersection.bind(this), {
        threshold: [0, 0.01]
      });
      this._intersectionObserver.observe(this._mainSubmitter);

      this._syncButtonState();
    }

    disconnectedCallback() {
      this._button?.removeEventListener('click', this._boundClick);
      if (this._sectionId && this._boundVariantChange) {
        document.removeEventListener('maximize:variant-picker:updated:' + this._sectionId, this._boundVariantChange);
        document.removeEventListener('maximize:color-swatch:change:' + this._sectionId, this._boundVariantChange);
      }
      this._buttonObserver?.disconnect();
      this._intersectionObserver?.disconnect();
      this._initialized = false;
    }

    _handleIntersection(entries) {
      var entry = entries[entries.length - 1];
      var hasPassedAboveViewport = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
      this._setVisible(hasPassedAboveViewport);
    }

    _setVisible(visible) {
      this.classList.toggle('is-visible', visible);
      this.setAttribute('aria-hidden', String(!visible));
    }

    _syncButtonState() {
      if (!this._mainSubmitter || !this._button) return;
      var nativeDisabled = this._mainSubmitter.disabled || this._mainSubmitter.getAttribute('aria-disabled') === 'true';
      var disabled = nativeDisabled || !this._variantAvailable;
      this._button.disabled = disabled;
      this._button.setAttribute('aria-disabled', String(disabled));
      this._availability.textContent = disabled
        ? this._mainSubmitter.textContent.trim()
        : this.dataset.availableText;
    }

    _handleVariantChange(event) {
      var variant = event.detail && event.detail.currentVariant;
      this._variantAvailable = Boolean(variant && variant.available);

      if (!variant) {
        this._availability.textContent = this.dataset.unavailableText;
        this._syncButtonState();
        return;
      }

      if (this._variant) {
        var title = variant.public_title || variant.title || '';
        var isDefaultTitle = !title || title === 'Default Title';
        this._variant.hidden = isDefaultTitle;
        this._variant.textContent = isDefaultTitle ? '' : title;
      }

      this._price.textContent = this._formatMoney(variant.price);
      var showComparePrice = Number(variant.compare_at_price) > Number(variant.price);
      this._comparePrice.hidden = !showComparePrice;
      this._comparePrice.textContent = showComparePrice ? this._formatMoney(variant.compare_at_price) : '';
      this._updateImage(variant);
      this._syncButtonState();
    }

    _formatMoney(cents) {
      if (typeof window.formatMoney === 'function') {
        return window.formatMoney(cents, this.dataset.moneyFormat);
      }
      return this._price.textContent;
    }

    _updateImage(variant) {
      if (!this._image || this._image.classList.contains('cs-product-sticky__image--placeholder')) return;
      var media = variant.featured_media || variant.featured_image;
      var preview = media && (media.preview_image || media);
      if (!preview || !preview.src) return;

      var imageUrl = new URL(preview.src, window.location.origin);
      imageUrl.searchParams.set('width', '160');
      this._image.src = imageUrl.toString();
      this._image.alt = media.alt || preview.alt || this._image.alt;
    }

    _handleClick() {
      if (this._button.disabled || !this._form || !this._mainSubmitter) return;

      var submitter = this._mainSubmitter;
      var forwarded = false;
      var forwardNativeClick = function (event) {
        if (event.submitter !== submitter) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (forwarded) return;
        forwarded = true;
        submitter.click();
      };

      this._form.addEventListener('submit', forwardNativeClick, { capture: true, once: true });
      try {
        this._form.requestSubmit(submitter);
      } finally {
        this._form.removeEventListener('submit', forwardNativeClick, true);
      }
    }
  }

  customElements.define('cs-product-sticky', CSProductSticky);
})();
